export default __webpack_public_path__ + "static/media/car.08f86ea8.svg";